import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

import { Currency } from '@sorare/core/src/__generated__/globalTypes';
import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

import { SelectHeader } from 'atoms/SelectHeader';

type Props = {
  options?: {
    value: Currency;
    label: string;
  }[];
  selectedCurrency: Currency;
  onChange: (currency: Currency) => void;
} & Pick<
  ComponentProps<typeof FilterInDropdown>,
  'buttonColor' | 'fullWidth' | 'buttonSize' | 'blur'
>;

export const SelectCurrency = ({
  options: optionsProps,
  selectedCurrency,
  onChange,
}: Props) => {
  const {
    fiatCurrency: { code },
    walletPreferences: { onlyShowFiatCurrency },
  } = useCurrentUserContext();

  const options = optionsProps || [
    {
      value: Currency.FIAT,
      label: code,
    },
    ...(!onlyShowFiatCurrency
      ? [
          {
            value: Currency.ETH,
            label: 'ETH',
          },
        ]
      : []),
  ];

  const selectedOption =
    options.find(o => o.value === selectedCurrency) || options[0];

  return (
    <FilterInDropdown buttonLabel={selectedOption.label} buttonSize="compact">
      {({ closeDropdown }) => (
        <>
          <SelectHeader>
            <FormattedMessage
              id="SelectCurrency.title"
              defaultMessage="Select currency"
            />
          </SelectHeader>
          <RadioGroup
            modalSelect
            options={options}
            value={selectedOption.value}
            name="currency-selector"
            onChange={currency => {
              onChange(currency);
              closeDropdown();
            }}
          />
        </>
      )}
    </FilterInDropdown>
  );
};
